import React from 'react';
import { Box, Typography } from '@mui/material';
import TmDownloadArrow from '../../icons/TmDownloadArrow';
import { homeService } from '../../services/homeService';
import { ContentTypes } from '../../constants/contentTypes';

export const DocumentsBlock: React.FC = () => {
    const handleDownload = async () => {
        try {
            const response = await homeService.downloadDriverImportTemplate();
            const blob = new Blob([response.data], {
                type: ContentTypes.Excel
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Образец заполнения списка сотрудников.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading template:', error);
        }
    };

    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#1A2229' }}>
                Документы
            </Typography>
            <Box
                onClick={handleDownload}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    p: 2.5,
                    border: '1px solid',
                    borderColor: '#9588e8',
                    borderRadius: 2,
                    cursor: 'pointer',
                    backgroundColor: 'white',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        backgroundColor: '#9588e8',
                        '& .doc-icon': {
                            color: 'white',
                        },
                        '& .doc-text': {
                            color: 'white',
                        },
                    },
                }}
            >
                <Box className="doc-icon" sx={{ color: '#9588e8', display: 'flex', alignItems: 'center' }}>
                    <TmDownloadArrow />
                </Box>
                <Typography className="doc-text" variant="body1" sx={{ color: '#9588e8' }}>
                    Образец заполнения списка сотрудников (xlsx)
                </Typography>
            </Box>
        </Box>
    );
};

